export default function R_Factors() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Factors Component</h1>
      <p>This is the R_Factors tutorial section.</p>
    </div>
  );
}
